import React from 'react'
import clsx from 'clsx'
import { Checkbox } from '@mui/material'

import OverflowTooltip from '../../../atoms/OverflowTooltip'
import FieldCopy from '../FieldCopy'

import useStyles from '../styles'

const CustomInputCheckbox = ({
  field,
  value,
  disabled,
  canEdit,
  handleChange,
  handleBlur,
  task,
  inputOnly,
  inTable
}) => {
  const [hovering, setHovering] = React.useState(false)
  const valueIsTrue = typeof value === 'boolean' ? value : value === 'true'
  const classes = useStyles({ readOnly: disabled, task, inputOnly, inTable })

  return (
    <div
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      className={clsx(
        classes.fieldInputRoot,
        classes.checkbox,
        'cf-input-root'
      )}
    >
      {!inputOnly && (
        <OverflowTooltip
          text={field.description}
          className={clsx(classes.label, 'label')}
        >
          {field.title}
        </OverflowTooltip>
      )}

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <FieldCopy
          inTable={inTable}
          visible={hovering}
          text={valueIsTrue ? 'Yes' : 'No'}
          style={{ left: 'calc(-100% - 5px)' }}
        />

        <Checkbox
          checked={valueIsTrue}
          onChange={e => {
            handleChange(e, field)
            handleBlur && handleBlur()
          }}
          disabled={disabled || !canEdit}
          className={classes.checkBox}
        />
      </div>
    </div>
  )
}

export default CustomInputCheckbox
